/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M16.5 0c1.6569 0 3 1.3432 3 3v5.6514A2.9863 2.9863 0 0 0 18 8.25V3c0-.7692-.5791-1.4033-1.3251-1.49L16.5 1.5H3c-.7692 0-1.4033.579-1.49 1.325L1.5 3v18c0 .7693.579 1.4033 1.325 1.4899L3 22.5h6c0 .8284.6716 1.5 1.5 1.5H3c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3h13.5ZM5.25 6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm-.75 5.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM5.25 15a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25-1.5c0-2.0711 1.6789-3.75 3.75-3.75S21 11.4289 21 13.5h.75c1.2426 0 2.25 1.0074 2.25 2.25v6c0 1.2426-1.0074 2.25-2.25 2.25h-9c-1.2426 0-2.25-1.0074-2.25-2.25v-6c0-1.2426 1.0074-2.25 2.25-2.25h.75Zm3.75-2.25c1.2426 0 2.25 1.0074 2.25 2.25H15c0-1.2426 1.0074-2.25 2.25-2.25ZM12.75 15h9a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 .75-.75Zm4.5 3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
    clipRule="evenodd"
  />,
  'Internal'
);
